import _ from 'lodash';
import { markets } from 'zeequant-constants';
import moment from 'moment';

export const LocaleUtils = () => {
  const { SA_LOCALE } = window;

  const locale = _.memoize(() => {
    return _.get(SA_LOCALE, 'locale', 'in').toLowerCase();
  });

  const localeConfig = markets[_.upperCase(locale())] || {};

  const lotSize = _.memoize((symbol, expiryDate) => {
    const formattedExpiryDate = moment(expiryDate, 'DDMMMYY').format('YYYY-MM-DD');

    return localeConfig.utility.getSymbolConfig(
      { symbol, date: formattedExpiryDate }
    )?.attributes?.lotSize;
  });

  const getAllSymbols = _.memoize(() => {
    return localeConfig.utility.getSymbols({ marketType: '*', isIndex: '*' });
  });

  const getCanonicalSymbol = _.memoize((symbol) => {
    if (isCrypto) return symbol;
    return _.includes(symbol, ':') ? _.split(symbol, ':')[1] : symbol;
  });

  const getHolidayDates = _.memoize(() => {
    return localeConfig.holidayDates;
  });

  const getWeekendWorkingDates = _.memoize(() => {
    return localeConfig.weekendWorkingDates;
  });

  const getMarketStartTime = _.memoize(() => {
    return localeConfig.startTime || '09:15';
  });

  const getMarketEndTime = _.memoize(
    () => {
      return localeConfig.endTime || '15:30';
    }
  );
  const getLotMultiplier = _.memoize((symbol) => {
    return localeConfig.utility.getLotMultiplier(symbol) || 1;
  },
    (symbol) => symbol
  );

  const resolveTimezone = (timezone) => {
    switch (timezone) {
      case 'IST':
        return 'Asia/Kolkata';
      case 'ET':
        return 'America/New_York';
      //TODO: Will maintain IST timings for delta exchange india...
      case 'UTC':
        return 'Asia/Kolkata';
      default:
        return timezone;
    }
  }

  const getTimezone = _.memoize(() => {
    return resolveTimezone(localeConfig.timeZone);
  });

  const isCrypto = _.memoize(() => locale() === 'crypto');

  const inrCryptocurrencyValue = 85; // 1 USD = 83.5 INR

  return {
    lotSize,
    getAllSymbols,
    getHolidayDates,
    getWeekendWorkingDates,
    getTimezone,
    getMarketStartTime,
    getMarketEndTime,
    isCrypto,
    getLotMultiplier,
    locale,
    inrCryptocurrencyValue,
    getCanonicalSymbol
  };
};
